import request from "@/utils/request";
import plaintextrequest from "@/utils/plaintextrequest";

//注册网易返回token
export function RegisterWy(data) {
  // console.log('注册网易返回token接口',data)
  return request({
    url: "/GroupWy/register",
    method: "post",
    data,
  });
}

// 获取网易token
export function getWyToken(data) {
  // console.log('获取网易token',data)
  return request({
    url: "/GroupWy/gettoken",
    method: "post",
    data,
  });
}

//群聊黑名单(进群前访问)
export function GroupWyBlack(data) {
  // console.log("请求黑名单接口传输的惨-------", data);
  return request({
    url: "/GroupWy/groupBlacklist",
    method: "post",
    data,
  });
}

//踢人出群
export function GroupWyKick(data) {
  // console.log('踢人传的参数--------',data)
  return request({
    url: "/GroupWy/kick",
    method: "post",
    data,
  });
}

//群公告
export function groupNotice(data) {
  return plaintextrequest({
    url: "/gameindex/groupNotice",
    method: "post",
    data,
  });
}

// 群主管理员撤回别人消息
export function recallOtherMsg(data) {
  // console.log('撤回别人消息传的参数------------------',data)
  return request({
    url: "/GroupWy/recallchat",
    method: "post",
    data,
  });
}

// 解散群聊
export function disSoveGroup(data) {
  return request({
    url: "/GroupWy/remove",
    method: "post",
    data,
  });
}

// 搜索群聊接口
export function searchGroup(data) {
  // console.log(data)
  return request({
    url: "/GroupWy/grouplist",
    method: "post",
    data,
  });
}

// 获取群用户信息
// export function getTeamMemberDetail(data) {
//   // console.log(data)
//   return request({
//     url: "/GroupWy/queryDetail",
//     method: "post",
//     data,
//   });
// }
export function getTeamMemberDetail(data) {
  // console.log(data)
  return plaintextrequest({
    url: "/GroupWy/queryDetailNew",
    method: "post",
    data,
  });
}

// 获取用户已加入群组的信息
export function getUserTeamInfo(data) {
  // console.log('获取用户已加入群组的信息传的数据-------',data)
  return request({
    url: "/GroupWy/joinTeams",
    method: "post",
    data,
  });
}
// 公告详情
export function groupNewsdetail(data) {
  return plaintextrequest({
    url: "/Information/newsdetail",
    method: "post",
    data,
  });
}

// 上传群聊消息
export function uploadGroupMsg(data) {
  // console.log('上传群聊消息传的数据-------',data)
  return request({
    url: "/GroupWy/chatHistory",
    method: "post",
    data,
  });
}

// 未加群时可读信息
export function unJoinGroup(data) {
  return request({
    url: "/publicH5/getgrouplog",
    method: "post",
    data,
  });
}
